module.exports = __webpack_public_path__ + "img/car350.a99cb276.png";